import React, { ElementType } from 'react';
import { Box, BoxProps } from '@mui/material';

export interface TabPanelProps extends BoxProps<ElementType> {
  /**
   *  currently selected tab
   */
  value?: number | string;
  /**
   *  index of the tab panel, when equals to value, content is shown
   */
  index?: number | string;
  /**
   * always keep the children in the DOM.
   * @default false
   */
  keepMounted?: boolean;
}

/**
 * Show or hide content based on the provided value and index
 */
export function TabPanel({ children, sx, value, index, keepMounted = false, ...rest }: TabPanelProps) {
  return (
    <Box
      role="tabpanel"
      data-testid={`TabPanel-${index}`}
      aria-hidden={value !== index}
      sx={{
        ...sx,
        ...(value !== index && { display: 'none' }),
      }}
      {...rest}
    >
      {(keepMounted || value === index) && children}
    </Box>
  );
}
